// src/components/chat/GroupMembersDropdown.jsx
import React from 'react';
import { API_URL } from '../../utils/constants';
import { formatLastSeen } from '../../utils/formatters';
import { getInitials, getAvatarColor } from '../../utils/userHelpers';
import './GroupMembersDropdown.css';

const GroupMembersDropdown = ({ members, loading, user, token }) => {
    return (
        <div className="members-dropdown">
            {loading ? (
                <div className="members-loading">Загрузка...</div>
            ) : members.length === 0 ? (
                <div className="members-empty">Нет участников</div>
            ) : (
                members.map(member => (
                    <div key={member.id} className="member-item">
                        <div className="member-avatar">
                            {member.avatar_url ? (
                                <img 
                                    src={`${API_URL}${member.avatar_url}?token=${token}`} 
                                    alt="" 
                                />
                            ) : (
                                <div 
                                    className="avatar-placeholder-small"
                                    style={{ backgroundColor: getAvatarColor(member.id) }}
                                >
                                    {getInitials(member.display_name || member.username || '?')}
                                </div>
                            )}
                            <span 
                                className={`member-status-dot ${member.is_online ? 'online' : 'offline'}`}
                            />
                        </div>
                        <div className="member-info">
                            <div className="member-name">
                                {member.display_name || member.username}
                                {member.id === user?.id && (
                                    <span className="member-you">(вы)</span>
                                )}
                            </div>
                            <div className="member-status-text">
                                {member.is_online 
                                    ? '🟢 В сети' 
                                    : formatLastSeen(member.last_seen)}
                            </div>
                        </div>
                    </div>
                ))
            )}
        </div>
    );
};

export default GroupMembersDropdown;